// extracted by mini-css-extract-plugin
export var md = "_2u-4";
export var semantic = "_2u-5";
export var sm = "_2u-3";
export var text = "_2u-6";
export var toggleInput = "_2u-0";
export var toggleSwitch = "_2u-1";
export var xs = "_2u-2";